import { BaseIconProps } from "../../types/styles";

const XMarkIcon = ({
    id,
    className,
    size = 24,
    customColor,
    onClick,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--neutral-600)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-xmark"}
            className={`${onClick && "cursor-pointer"}${className ? ` ${className}` : ""}`}
            onClick={onClick}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18 6L6 18"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6 6L18 18"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default XMarkIcon;
